var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OPEN_RATE_COLUMN_ID } from './columns/constants';
import { isDraft } from '../../../campaign-utils';
export var shouldShowOpenRate = function (campaign) { return !isDraft(campaign.campaignInstance); };
export var shouldShowCellData = function (cell) {
    var campaign = cell.row.original;
    if (cell.column.columnDef.id === OPEN_RATE_COLUMN_ID) {
        return shouldShowOpenRate(campaign);
    }
    return true;
};
export var getAutomatedTableData = function (campaigns) {
    return campaigns.map(function (campaign) {
        var _a, _b, _c;
        var instance = campaign.campaignInstance;
        var audience = campaign.definition.customerGroups.map(function (group) { return group.name; });
        var totalAudienceCount = (_a = instance === null || instance === void 0 ? void 0 : instance.totalCustomersNotified) !== null && _a !== void 0 ? _a : 0;
        var totalUniqueOpenRateCounter = (_b = instance === null || instance === void 0 ? void 0 : instance.totalUniqueOpenRateCounter) !== null && _b !== void 0 ? _b : 0;
        var openRate = totalAudienceCount > 0 ? (100 * totalUniqueOpenRateCounter) / totalAudienceCount : 0;
        var userCount = totalAudienceCount;
        var isRecurring = !!(instance === null || instance === void 0 ? void 0 : instance.recurring);
        var frequency = campaign.definition.recurrence.name;
        var sinceDate = ((_c = instance === null || instance === void 0 ? void 0 : instance.recurrenceRule) === null || _c === void 0 ? void 0 : _c.start) || campaign.createdAt;
        return __assign(__assign({}, campaign), { name: campaign.definition.name, description: campaign.definition.description, audience: audience, totalAudienceCount: totalAudienceCount, openRate: openRate, userCount: userCount, frequency: frequency, isRecurring: isRecurring, sinceDate: sinceDate });
    });
};
